/**
 * Revenue Repository
 * 매출 데이터 API 호출 계층
 */
import type { RevenueData, PlanDistribution, TimeSlotRevenue, PeriodType } from '../models/Revenue';

export class RevenueRepository {
  /**
   * 일별 매출 데이터 조회
   */
  async getDailyRevenue(period: PeriodType): Promise<RevenueData[]> {
    const response = await fetch(`/api/v1/owner/revenue/daily?period=${period}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      throw new Error('일별 매출 데이터 조회 실패');
    }

    return await response.json();
  }

  /**
   * 요금제별 매출 분포 조회
   */
  async getPlanDistribution(period: PeriodType): Promise<PlanDistribution[]> {
    const response = await fetch(`/api/v1/owner/revenue/plans?period=${period}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      throw new Error('요금제별 매출 분포 조회 실패');
    }

    return await response.json();
  }

  /**
   * 시간대별 매출 데이터 조회
   */
  async getTimeSlotRevenue(period: PeriodType): Promise<TimeSlotRevenue[]> {
    const response = await fetch(`/api/v1/owner/revenue/timeslots?period=${period}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      throw new Error('시간대별 매출 데이터 조회 실패');
    }

    return await response.json();
  }
}

export const revenueRepository = new RevenueRepository();
